import { __extends } from "tslib";
import { StartSegmentDetectionRequest, StartSegmentDetectionResponse } from "../models/models_0";
import { deserializeAws_json1_1StartSegmentDetectionCommand, serializeAws_json1_1StartSegmentDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartSegmentDetectionCommand = /** @class */ (function (_super) {
    __extends(StartSegmentDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartSegmentDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartSegmentDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "StartSegmentDetectionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StartSegmentDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartSegmentDetectionResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartSegmentDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartSegmentDetectionCommand(input, context);
    };
    StartSegmentDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartSegmentDetectionCommand(output, context);
    };
    return StartSegmentDetectionCommand;
}($Command));
export { StartSegmentDetectionCommand };
//# sourceMappingURL=StartSegmentDetectionCommand.js.map